import { selectComponentDefinitions } from "./groupDefinitions";

export const contentComponents = selectComponentDefinitions([
    "Highlight",
    "Multistep Indicator",
    "Bubble Headline",
    "Message Box",
    "DT Milestones",
    "DT Carousel",
]);
